// Core
import { createStore, applyMiddleware } from 'redux';

// Packages
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reduxThunk from 'redux-thunk';

// Reducers
import rootReducer from './rootReducer';

// Persist config
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'session', 'app'],
};

// The store
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  persistedReducer,
  applyMiddleware(reduxThunk),
);

export const persistor = persistStore(store);
